import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { String } from 'typescript-string-operations';
import { RootService } from './root.service';

@Injectable({
  providedIn: 'root'
})
export class TicketsService {

  BaseURI : string ;
  constructor(private http:HttpClient,private rootService : RootService) {
    this.BaseURI =  this.rootService.GetBaseURL();
   }

  getTicketList(){
     return this.http.get(this.BaseURI + '/CSP/get-all-tickets').pipe(map(res => res));
  }

  getMyTicketList(userId){
    return this.http.get(this.BaseURI +  `/CSP/get-my-tickets?userId=${userId}`).pipe(map(res => res));
  }
  // Changed this route to match the partner response
  getMySubscriptionList(partnerId){
    return this.http.get(this.BaseURI +  `/CSP/get-my-subscription?partnerId=${partnerId}`).pipe(map(res => res));
  }

  getAttachedFilesInTickets(ticketId){    
    return this.http.get<any>(String.Format(this.BaseURI + '/CSP/get-attached-files/{0}', ticketId)).pipe(map( res => <any>res));
  }

  getOverDueTickets(userId){
    return this.http.get(this.BaseURI +  `/CSP/get-over-due-tickets?userId=${userId}`).pipe(map(res => res));
  }

  createTicket(param) {
    return this.http.post(this.BaseURI + '/CSP/create-ticket', param).pipe(map(res => res));
  }

  updateTicket(param) {    
    return this.http.put(this.BaseURI + '/CSP/update-ticket', param).pipe(map(res => res));
  }

  
  AssignTicketToMe(param) {    
    return this.http.post(this.BaseURI + '/CSP/assign-ticket-to-me', param).pipe(map(res => res));
  }

  getTicketStatusList() {    
    return this.http.get(this.BaseURI + '/CSP/get-all-ticketStatus').pipe(map(res => res));
  }

  getTicket(id){
    return this.http.get<any>(String.Format(this.BaseURI + '/CSP/get-ticket/{0}', id)).pipe(map( res => <any>res));
  }

  // Added a new function for Updating Subscriptions
  updateSubscription(quantity:number,partnerCenterId:string,subscriptionId:string,quantityInitial:number,email:string,company:string,license:string, currentSubscription: any){
    let param = {
      Quantity: quantity,
      PartnerCenterId: partnerCenterId,
      SubscriptionId: subscriptionId,
      InitialQuantity:quantityInitial,
      CompanyName:company,
      Email:email,
      LicenseName:license,
      OriginalSubscription: currentSubscription
    }
    return this.http.patch(this.BaseURI +  '/CSP/update-my-subscription',param);
  }
}
